import React, { useEffect, useState, useCallback } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { db } from './firebaseConfig'; // Import db
import { collection, addDoc, serverTimestamp, doc, getDoc, setDoc } from 'firebase/firestore'; // Import Firestore functions
import Navbar from './components/Navbar';
import AdminUserManagement from './components/AdminUserManagement'; // Import AdminUserManagement
import Home from './components/Home';
import Menu from './components/Menu'; // This is the carousel for the home page
import Experiencias from './components/Experiencias'; // Import CircularGallery component
import Reservas from './components/Reservas'; // This is the section for the home page
import HomeSalones from './components/HomeSalones'; // Import the new Home Salones component
import EventConfigurator from './components/EventConfigurator'; // Import the new event configurator


import Resenas from './components/Resenas'; // Changed from Galeria to Resenas
import Contacto from './components/Contacto';
import MenuPage from './components/MenuPage'; // The detailed menu page
import ExperienciasPage from './components/ExperienciasPage'; // The detailed experiences page
import ReservasPage from '././components/ReservasPage'; // The detailed reservations page
import BookingPage from './components/BookingPage'; // The new booking page
import Footer from './components/Footer'; // Import the Footer component
import SocialWidgets from './components/SocialWidgets';
import WhatsAppWidget from './components/WhatsAppWidget';
import useIntersectionObserver from './hooks/useIntersectionObserver';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import EventSpaceDetail from './components/EventSpaceDetail'; // Import the new component
import PromotionsPage from './components/PromotionsPage'; // Importa la página de promociones
import PromotionDetailPage from './components/PromotionDetailPage'; // Importa el detalle de la promoción
import CheckoutPage from './components/CheckoutPage'; // Importa la nueva página de Checkout
import CheckoutDeliveryPage from './components/CheckoutDeliveryPage'; // Importa la nueva página de Checkout para domicilios
import AdminPromotions from './components/AdminPromotions'; // Importa el admin de promociones
import AdminPromotionBookings from './components/AdminPromotionBookings'; // Importa el admin de reservas de promoción
import AdminReservationsManagement from './components/AdminReservationsManagement'; // Importa el nuevo componente de gestión de reservas
import PaymentStatusPage from './components/PaymentStatusPage'; // Importa la nueva página de estado de pago
import BazurtoChatbot from './components/chatbot/Chatbot'; // Import the chatbot component
import Cart from './components/Cart';
import { FaShoppingCart } from 'react-icons/fa';
import { useCart } from './context/CartContext'; // Import useCart
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const sectionIds = ['home', 'experiencias', 'reservas', 'menu', 'salones', 'resenas', 'contacto']; // Updated section ID
  const activeSection = useIntersectionObserver(sectionIds);
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null); // New state for user role
  const [userPermissions, setUserPermissions] = useState({}); // New state for user permissions
  const [loading, setLoading] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { clearCart } = useCart(); // Get clearCart from useCart

  // Estas funciones se pasarán a CheckoutPage


  // Handlers for general checkout (cart items)
  const handleGeneralWompiPayment = useCallback(async (orderDetails) => {
    console.log("Initiating general Wompi payment with:", orderDetails);
    const { customerData, cartItems, totalPrice } = orderDetails;

    if (!customerData || !cartItems || totalPrice === undefined) {
      console.error("Faltan datos esenciales para el pago general con Wompi.");
      alert("Faltan datos esenciales para el pago. Por favor, contacta a soporte.");
      return;
    }

    const reference = `CART_${Date.now()}_${customerData.fullName.replace(/\s/g, '')}`;
    const amountInCents = totalPrice * 100;
    const finalRedirectUrl = `${process.env.REACT_APP_BASE_URL.replace(/[/]+$/, '')}/payment-success`;

    try {
            const functionUrl = `https://us-central1-yoamobazurto-f86de.cloudfunctions.net/wompi/signature`;
      
            console.log("Client-side: Requesting Wompi signature with:", { reference, amountInCents, currency: 'COP' });
            const response = await fetch(functionUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                reference: reference,
                amountInCents: amountInCents,
                currency: 'COP',
              }),
            });
      
            if (!response.ok) {
              const errorBody = await response.text();
              throw new Error(`Error al obtener la firma de Wompi: ${response.status} ${errorBody}`);
            }
      
            const { signature } = await response.json();
      
                                          const wompiPublicKey = 'pub_prod_bOTiNiffoeGpv4F9srEOSzFrOwcTQDhE'; // Define as a constant
      
                                
      
                                          if (window.WidgetCheckout) {
      
                                            const checkout = new window.WidgetCheckout({
      
                                              currency: 'COP',
      
                                              amountInCents: amountInCents,
      
                                              reference: reference,
      
                                              publicKey: wompiPublicKey, // Use the constant
      
                                              signature: {
      
                                                integrity: signature
      
                                              },
      
                                              redirectUrl: finalRedirectUrl,
      
                                              expirationTime: undefined, // Explicitly set to undefined
      
                                            });
      
                                
      
                                            checkout.open(function (result) {
      
                                              console.log("Wompi checkout.open callback fired. Transaction status:", result.transaction.status);
      
                                            });
      
                                          } else {
      
                                            console.error("Wompi WidgetCheckout script not loaded.");
      
                                            alert("El script de pago de Wompi no se ha cargado correctamente. Por favor, intenta de nuevo.");
      
                                          }

    } catch (error) {
      console.error("Error en el proceso de pago general con Wompi:", error);
      alert("Hubo un problema al procesar el pago. Por favor, intenta de nuevo.");
    }
  }, []);

  const handleGeneralBankTransfer = useCallback(async (orderDetails) => {
    console.log("Initiating general Bank Transfer with:", orderDetails);

    if (!orderDetails || !orderDetails.customerData || !orderDetails.cartItems || orderDetails.precioTotal === undefined) {
      alert("Faltan datos esenciales para la reserva por transferencia. Por favor, contacta a soporte.");
      return;
    }

    try {
      const docRef = await addDoc(collection(db, 'deliveryOrders'), {
        ...orderDetails,
        paymentMethod: 'bankTransfer',
        status: 'pending_transfer',
        createdAt: serverTimestamp(),
      });
      // clearCart(); // This will be called on modal close
      // alert("Pedido realizado con éxito. Por favor, completa la transferencia bancaria.");
      // navigate('/payment-success'); // Navigation will be handled by CheckoutDeliveryPage
    } catch (error) {
      console.error("Error al guardar el pedido por transferencia:", error);
      alert("Hubo un problema al procesar tu pedido. Por favor, intenta de nuevo.");
    }
  }, []);

  // Handlers for promotion checkout
  const handlePromotionWompiPayment = useCallback(async (customerData, promotionDetails, selectedOptionDetails, selectedDate, quantity) => {
    console.log("Initiating promotion Wompi payment with:", { customerData, promotionDetails, selectedOptionDetails, selectedDate, quantity });

    if (!customerData || !promotionDetails || !selectedOptionDetails) {
      console.error("Faltan datos esenciales para el pago de la promoción con Wompi.");
      alert("Faltan datos esenciales para el pago. Por favor, contacta a soporte.");
      return;
    }

    if (!customerData.email || !customerData.fullName || !customerData.phoneNumber) {
      alert("Por favor, completa todos los datos del cliente (email, nombre completo, teléfono) para el pago con Wompi.");
      return;
    }

    const reference = `PROMO${promotionDetails.id}${selectedOptionDetails.id}${Date.now()}`.replace(/[^a-zA-Z0-9]/g, '');
    const amountInCents = selectedOptionDetails.price * 100;
    const finalRedirectUrl = `${process.env.REACT_APP_BASE_URL.replace(/[/]+$/, '')}/payment-success`;

    try {
      // 1. Create reservation in Firestore with 'pending' status
      const docRef = await addDoc(collection(db, 'promotionBookings'), {
        promotionId: promotionDetails.id,
        promotionTitle: promotionDetails.title,
        optionId: selectedOptionDetails.id,
        optionName: selectedOptionDetails.name,
        price: selectedOptionDetails.price,
        selectedDate: selectedDate, // Add selectedDate here
        quantity: quantity, // Add quantity here
        customerData,
        paymentMethod: 'wompi',
        paymentStatus: 'pending',
        paymentReference: reference,
        createdAt: serverTimestamp(),
      });
      console.log("Promotion booking created with ID: ", docRef.id);

      // 2. Get signature from Firebase Function
      const functionUrl = 'https://us-central1-yoamobazurto-f86de.cloudfunctions.net/wompi/signature';

      console.log("Client-side: Requesting Wompi signature with:", { reference, amountInCents, currency: 'COP' });
      const response = await fetch(functionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          reference: reference,
          amountInCents: amountInCents,
          currency: 'COP',
        }),
      });

      if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(`Error al obtener la firma de Wompi: ${response.status} ${errorBody}`);
      }

      const { signature } = await response.json();

      // 3. Open Wompi checkout
      const checkout = new window.WidgetCheckout({
        currency: 'COP',
        amountInCents: amountInCents,
        reference: reference,
        publicKey: 'pub_prod_bOTiNiffoeGpv4F9srEOSzFrOwcTQDhE', // Use your actual public key
        signature: {
          integrity: signature
        },
        redirectUrl: finalRedirectUrl,
        customerData: {
          email: customerData.email,
          fullName: customerData.fullName,
          phoneNumber: customerData.phoneNumber,
          phoneNumberPrefix: '+57', // Assuming +57 for Colombia
        }
      });

      checkout.open(function (result) {
        console.log("Wompi checkout.open callback fired. Transaction status:", result.transaction.status);
      });
    } catch (error) {
      console.error("Error en el proceso de pago de la promoción con Wompi:", error);
      alert("Hubo un problema al procesar el pago. Por favor, intenta de nuevo.");
    }
  }, []);

  const handlePromotionBankTransfer = useCallback(async (customerData, promotionDetails, selectedOptionDetails, selectedDate, quantity) => {
    console.log("Initiating promotion Bank Transfer with:", { customerData, promotionDetails, selectedOptionDetails, selectedDate, quantity });

    if (!customerData || !promotionDetails || !selectedOptionDetails || !selectedOptionDetails.id) {
      alert("Faltan datos esenciales para la reserva por transferencia (ID de opción). Por favor, contacta a soporte.");
      return;
    }

    try {
      await addDoc(collection(db, 'promotionBookings'), {
        promotionId: promotionDetails.id,
        promotionTitle: promotionDetails.title,
        optionId: selectedOptionDetails.id,
        optionName: selectedOptionDetails.name,
        price: selectedOptionDetails.price,
        selectedDate: selectedDate, // Add selectedDate here
        quantity: quantity, // Add quantity here
        customerData,
        paymentMethod: 'bankTransfer',
        status: 'pending_transfer',
        createdAt: serverTimestamp(),
      });
      alert("Reserva realizada con éxito. Por favor, completa la transferencia bancaria.");
      // closeModal(); // No modal to close here
      // navigate('/payment-success'); // Navigation will be handled by CheckoutPage
    } catch (error) {
      console.error("Error al guardar la reserva por transferencia:", error);
      alert("Hubo un problema al procesar tu reserva. Por favor, intenta de nuevo.");
    }
  }, []);

  const [wompiPaymentHandler, setWompiPaymentHandler] = useState(() => () => console.log("Wompi handler not set"));
  const [bankTransferHandler, setBankTransferHandler] = useState(() => () => console.log("Bank transfer handler not set"));

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setIsScrolled(offset > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        const userRef = doc(db, 'users', currentUser.uid);
        const userDocSnap = await getDoc(userRef);

        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
          setUserRole(userData.role);
          setUserPermissions(userData.permissions || {});
        } else {
          // If user exists in auth but not in Firestore, create a default user document
          await setDoc(userRef, {
            email: currentUser.email,
            role: 'user', // Assign a default role
            permissions: {},
            createdAt: new Date(),
          });
          setUserRole('user');
          setUserPermissions({});
        }
      } else {
        setUserRole(null); // Clear role if no user
        setUserPermissions({}); // Clear permissions if no user
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [db]); // Added db to dependency array

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  if (loading) {
    return <div>Cargando...</div>; // O un spinner de carga
  }

  const hideWidgets = location.pathname === '/checkout' || location.pathname === '/checkout-delivery' || location.pathname === '/payment-success' || location.pathname.startsWith('/admin');
  const showCart = location.pathname === '/menu';

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  return (
    <div className="App">
      <Navbar activeSection={activeSection} isScrolled={isScrolled} />
      <Routes>
        <Route path="/" element={
          <>
            <Home isScrolled={isScrolled} />
            <Experiencias id="experiencias" />
            <Reservas id="reservas" />
            <Menu id="menu" />
            <HomeSalones id="salones" />
            <Resenas id="resenas" />
            <Contacto id="contacto" />
          </>
        } />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/experiencias" element={<ExperienciasPage />} />
        <Route path="/reservas" element={<BookingPage />} />
        <Route path="/salones" element={<EventConfigurator />} />
        <Route path="/reservas/:sedeId" element={<BookingPage />} />
        <Route path="/salon/:id" element={<EventSpaceDetail />} /> {/* New route for event space detail */}
        
        {/* --- RUTAS PARA PROMOCIONES Y CHECKOUT --- */}
        <Route path="/eventos" element={<PromotionsPage />} />
        <Route
          path="/eventos/:id"
          element={<PromotionDetailPage
            setWompiPaymentHandler={setWompiPaymentHandler}
            setBankTransferHandler={setBankTransferHandler}
          />}
        />
        <Route
          path="/checkout"
          element={(() => {
            const storedPromotion = localStorage.getItem('selectedPromotionForCheckout');
            const storedOption = localStorage.getItem('selectedPromotionOptionForCheckout');
            const storedDate = localStorage.getItem('selectedPromotionDateForCheckout');
            const isPromotionCheckout = storedPromotion && storedOption;

            const wompiHandler = isPromotionCheckout ? (customerData, promotionDetails, selectedOptionDetails, quantity) => handlePromotionWompiPayment(customerData, promotionDetails, selectedOptionDetails, storedDate, quantity) : handleGeneralWompiPayment;
            const bankTransferHandler = isPromotionCheckout ? (customerData, promotionDetails, selectedOptionDetails, quantity) => handlePromotionBankTransfer(customerData, promotionDetails, selectedOptionDetails, storedDate, quantity) : handleGeneralBankTransfer;

            return (
              <CheckoutPage 
                onWompiPayment={wompiHandler}
                onBankTransfer={bankTransferHandler}
                key={isPromotionCheckout ? 'promotion-checkout' : 'general-checkout'}
              />
            );
          })()} 
        />        <Route
          path="/checkout-delivery"
          element={<CheckoutDeliveryPage
            onWompiPayment={handleGeneralWompiPayment}
            onBankTransfer={handleGeneralBankTransfer}
          />}
        />
        <Route path="/payment-success" element={<PaymentStatusPage />} /> {/* Nueva ruta para el estado del pago */}
        
        {/* --- RUTAS DE ADMINISTRADOR --- */}
        <Route path="/admin" element={user ? <AdminDashboard userRole={userRole} userPermissions={userPermissions} /> : <AdminLogin />} />
        <Route path="/admin/promotions" element={<ProtectedRoute user={user} userPermissions={userPermissions} permission="promotionsConfig"><AdminPromotions /></ProtectedRoute>} />
        <Route path="/admin/promotions/:promotionId/reservas" element={<ProtectedRoute user={user} userPermissions={userPermissions} permission="promotionBookings"><AdminPromotionBookings /></ProtectedRoute>} />
        <Route path="/admin/reservationsManagement" element={<ProtectedRoute user={user} userPermissions={userPermissions} permission="reservationsManagement"><AdminReservationsManagement /></ProtectedRoute>} />
        <Route path="/admin/users" element={<ProtectedRoute user={user} userPermissions={userPermissions} permission="userManagement"><AdminUserManagement /></ProtectedRoute>} />
        

      </Routes>
      <Footer /> {/* Add the Footer component here */}
      {!hideWidgets && !isCartOpen && location.pathname !== '/menu' && <SocialWidgets />}
      {!hideWidgets && !isCartOpen && location.pathname !== '/menu' && <WhatsAppWidget />}
      {showCart && (
        <div className="cart-fab" onClick={toggleCart}>
          <FaShoppingCart />
        </div>
      )}
      <div className={`cart-container ${isCartOpen ? 'open' : ''}`}>
        <Cart toggleCart={toggleCart} />
      </div>
      {!hideWidgets && <BazurtoChatbot />}
    </div>
  );
}

export default App;